
import { defineComponent } from "vue";
import { getDetail, Delete } from "@/api/suppliesApi";
import runEvn from "@/modular/runEvn/RunEvn";
import { previewImage } from "@/modular/Weixinh5";
import { useRoute, useRouter } from "vue-router";
import { copyText } from "@/modular/Copy";

const fileBaseUrl = runEvn().fileBaseUrl;

export default defineComponent({
    name: "About",
    setup() {
        const router = useRouter();
        return {
            router,
            route: useRoute(),
        };
    },
    // activated() {
    //     this.getDetail();
    // },
    mounted(){
        this.getDetail();
    },
    computed: {
        aduitsCheck() {
            var classstr = "";
            if (this.suppliesInfo.supplierStatus >= 2)
                classstr = "d-flex-1f d-center  active";
            else classstr = "d-flex-1f d-center inactive";

            return classstr;
        },
        completeCheck() {
            var classstr = "";
            if (this.suppliesInfo.donateStatus == 3)
                classstr = "d-flex-1f d-center  active";
            else classstr = "d-flex-1f d-center inactive";
            return classstr;
        },
    },
    components: {},
    props: {
        id: {
            type: String,
        },
    },
    data() {
        return {
            show: false,
            data: {
                imgs: [],
                suppliesImgs: [],
            },
            suppliesInfo: {} as any,
        };
    },
    methods: {
        copy(text) {
            copyText(text);
            this.$toast.success("复制成功");
        },
        async getDetail() {
            const data = await getDetail(this.id);

            if (!data) {
                // 没有查询到数据，当作被删除，提示并返回
                await this.$dialog.alert({ message: "该信息已经被删除" });
                this.router.go(-1);
                return;
            }
            this.suppliesInfo = data;

            if (this.suppliesInfo.donateImgs) {
                this.data.imgs = this.suppliesInfo.donateImgs.split(",");
            }
            if (this.suppliesInfo.suppliesImgs) {
                this.data.suppliesImgs =
                    this.suppliesInfo.suppliesImgs.split(",");
            }
        },
        async previewImage(imgKey: string) {
            await previewImage({
                current: this.img(imgKey),
                urls: this.data.imgs.map((item) => this.img(item)),
            });
        },
        async previewSuppliesImgs(imgKey: string) {
            await previewImage({
                current: this.img(imgKey),
                urls: this.data.suppliesImgs.map((item) => this.img(item)),
            });
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        isShowDonation() {
            if (
                this.suppliesInfo.donateTo != null &&
                this.suppliesInfo.donateTo != ""
            ) {
                return true;
            }
            return false;
        },
        isShowRefuseMsg() {
            if (
                this.suppliesInfo.refuseMsg != null &&
                this.suppliesInfo.refuseMsg != ""
            ) {
                return true;
            }
            return false;
        },
        isShowSerialNumber() {
            if (
                this.suppliesInfo.serialNumber != null &&
                this.suppliesInfo.serialNumber != ""
            ) {
                return true;
            }
            return false;
        },
        isShowEdit() {
            if (!this.suppliesInfo.isMy) {
                return false;
            }
            if (this.suppliesInfo.supplierStatus == 2) {
                //通过审核
                return false;
            }
            if (this.suppliesInfo.supplierStatus == 3) {
                //拒绝审核
                return false;
            }

            return true;
        },
        async Delete() {
            this.$dialog
                .confirm({
                    title: "提示",
                    message: "是否删除捐献物资",
                })
                .then(async () => {
                    // on confirm
                    var isOK = await Delete(this.id);
                    if (isOK) {
                        const _this = this;
                        this.$toast.success({
                            // type: "success",
                            message: "修改成功",
                            // name
                            onOpened: () => {
                                _this.router.back();
                            },
                        });
                    }
                })
                .catch(() => {
                    // on cancel
                });
        },
        async Update() {
            this.router.push(`/gy/donation/edit/${this.id}`);
        },
    },
});
